import * as tslib_1 from "tslib";
import Typography from '../Typography';
/**
 * 获取文本颜色
 *
 * @export
 * @param {(FormHelpTextProps & {
 *     theme: Theme;
 *   })} props FormHelperText组件属性
 * @returns
 */
export function getTextColor(props) {
    if (props.error) {
        return props.theme.palette.error[500];
    }
    else if (props.success) {
        return props.theme.palette.success.A700;
    }
    else if (props.warning) {
        return props.theme.palette.warning[500];
    }
    return props.theme.palette.text.secondary;
}
/**
 * 表单帮助性文本组件
 *
 * @ReactComponent
 */
var FormHelpText = Typography.extend.attrs({
    type: 'caption',
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-top: ", "px;\n  text-align: left;\n  color: ", ";\n"], ["\n  margin-top: ", "px;\n  text-align: left;\n  color: ", ";\n"])), function (props) { return props.theme.spacing.unit; }, function (props) { return getTextColor(props); });
export default FormHelpText;
var templateObject_1;
//# sourceMappingURL=FormHelpText.js.map